export default __webpack_public_path__ + "static/media/AneomiClosed3.ab5488ca.jpg";